import { render, staticRenderFns } from "./imgRadiobox.vue?vue&type=template&id=c1f8863a&scoped=true&"
import script from "./imgRadiobox.vue?vue&type=script&lang=js&"
export * from "./imgRadiobox.vue?vue&type=script&lang=js&"
import style0 from "./imgRadiobox.vue?vue&type=style&index=0&id=c1f8863a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f8863a",
  null
  
)

export default component.exports